import React, {Component} from "react";
import "./index.css"
import BsySLoading from "../BsySLoading";

class BsySelectAppPane extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      searchItems: [],
      isLoading: true
    }
  }
  componentDidMount() {
    React.axios("/dashboard/app_group/list").then(res => {
      const apps = [];
      res.data.items.map(res1 => {
        res1.apps.map(res2 => {
          res2.appType === 1 && apps.push(res2)
        })
      })
      this.setState({items: apps, searchItems: apps, isLoading: false})
      this.props.getContext(this)
    })
  }

  RemoveValByIndex = (arr, index, length) => {
    let reg = new RegExp(index, "g");
    return arr.replace(reg, length);
  }

  searchApp = (e) => {
    this.searchTime && clearTimeout(this.searchTime);
    this.searchTime = setTimeout(() => {
      const {items} = this.state;
      const key = e.target.value;
      const apps = [];
      items.map(res => {
        if (res.appname.indexOf(key) > -1) {
          apps.push(res)
          res.titleHtml = this.RemoveValByIndex(res.appname, key, '<i style="color: #0265ff;font-style: normal;">' + key + '</i>');
        }
      })
      if (key === "" || key === " ") {
        this.setState({searchItems: items})
      } else {
        this.setState({searchItems: apps})
      }
    }, 300)
  }

  selectStandardAppId = "";

  selectApp = (item) => {
    return (e) => {
      e.currentTarget.parentNode.getElementsByClassName("select").length > 0 && e.currentTarget.parentNode.getElementsByClassName("select")[0].classList.remove("select");
      e.currentTarget.classList.add("select");
      this.selectStandardAppId = item._id;
    }
  }

  render() {
    const {searchItems, isLoading} = this.state;
    return <div className="BsySelectAppPane">
      {isLoading && <BsySLoading style={{background: '#ffffff'}}/>}
      <div className="pane-header">
        <div className="header-title">{React.language("copy.standard.msg")}</div>
        <div className="search-box">
          <input type="text" placeholder={React.language("standard.search.placeholder")} onChange={this.searchApp}/>
          <div className="searchIcon">
            <i className="icon-bsy-reportmenu-0"></i>
          </div>
        </div>
      </div>
      <div className="pane-body">
        {
          searchItems.map(res1 => {
            return <div className="appItems" onClick={this.selectApp(res1)}>
              <div className="app-wrapper">
                <div className="icon-wrapper">
                  <div className={`icon-backgroup color-cover-${res1.style.color}`}>
                    <div className={`imgbg-bsy-app imgbg-bsy-app-${res1.style.icon}`}></div>
                  </div>
                </div>
                {res1.titleHtml ? <div className="app-title" dangerouslySetInnerHTML={{__html: res1.titleHtml}} title={res1.appname}></div> : <div className="app-title" title={res1.appname}>{res1.appname}</div>}
              </div>
              <i className="icon-bsy-check3"></i>
            </div>
          })
        }
      </div>
    </div>
  }
}

export default BsySelectAppPane;